import { AutogenModelEdiCustomer, AutogenRowEdiCustomer } from "./autogen/AutogenModelEdiCustomer";

export class ModelEdiCustomer extends AutogenModelEdiCustomer<RowEdiCustomer> {
    constructor() {
        super(RowEdiCustomer);
    }
}

export class RowEdiCustomer extends AutogenRowEdiCustomer {
}